import * as ActionTypes from '@js/constants/actionTypes';

import api from '@js/middlewares/api';

// Blog
export const fetchBlog = (userId, options = {}) => ({
    actionType: ActionTypes.BLOG,
    fetchAPI: () => api.get(`/api/users/${userId}/blog`, {
        force_locale: window.locale,
        ...options
    })
});

const receiveBlogTags = (json) => ({
    type: ActionTypes.BLOG_TAGS_FETCH_SUCCESS,
    tags: json.blogTags
});
export const fetchBlogTags = (userId) => (dispatch) => {
    return api
        .get(`/api/users/${userId}/blog/tags`, {
            force_locale: window.locale
        })
        .request
        .then((json) => dispatch(receiveBlogTags(json)));
};

// BlogArticle
export const fetchBlogArticle = (userId, articleId, isAdmin = false) => ({
    actionType: ActionTypes.BLOG_ARTICLE,
    fetchAPI: () => api.get(`/api/users/${userId}/blog/articles/${articleId}`, {
        force_locale: window.locale,
        isAdmin
    })
});

// Blog article mutations
export const toggleEditMode = () => ({
    type: ActionTypes.BLOG_ARTICLE_EDITION_TOGGLE
});

export const addBlogArticle = (userId, blogArticle, options = {}) => ({
    actionType: ActionTypes.BLOG_ARTICLE,
    mutationAPI: () => api.post(`/api/users/${userId}/blog/articles`, {
        force_locale: window.locale,
        blogArticle,
        ...options
    })
});

export const updateBlogArticle = (userId, blogArticleId, blogArticle, isAdmin = false) => ({
    actionType: ActionTypes.BLOG_ARTICLE,
    mutationAPI: () => api.update(`/api/users/${userId}/blog/articles/${blogArticleId}`, {
        force_locale: window.locale,
        blogArticle,
        isAdmin
    })
});

export const deleteBlogArticle = (userId, blogArticleId) => ({
    actionType: ActionTypes.BLOG_ARTICLE,
    mutationAPI: () => api.delete(`/api/users/${userId}/blog/articles/${blogArticleId}`, {
        force_locale: window.locale
    }),
    payload: {
        removedId: blogArticleId
    }
});
